<template>
  <!-- <v-row justify="center"> -->
  <v-dialog v-model="dialog" width="500" transition="dialog-bottom-transition">
    <!-- <v-sheet height="400" class="overflow-hidden" style="position: relative"> -->
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-container class="fill-height">
          <v-row align="center" justify="center"> -->
      <v-row class="justify-center">
        <v-btn
          color="primary white--text"
          filled
          min-width="150"
          max-width="150"
          v-bind="attrs"
          v-on="on"
          @click="$emit('updateUserEmail')"
          style="text-transform: none"
        >
          Submit
        </v-btn>
      </v-row>
      <!--  </v-container> -->
    </template>
    <!-- <v-navigation-drawer width="auto" v-model="drawer" absolute temporary> -->
    <v-card class="cardBg" flat outlined width="600px">
      <v-card flat>
        <v-form ref="form">
          <v-container fluid>
            <v-row>
              <v-col>
                <v-card-title style="word-break: break-word"
                  >Verify Email</v-card-title
                >
                <v-card-text>
                  <div class="grey--text">
                    <h4>
                      Your security is our top priority. In order to protect our
                      users, each email address is verified before an email can
                      be changed.
                    </h4>
                    <li>
                      We have sent you an email containing a code which you
                      enter here.
                    </li>
                    <li>
                      In some cases, this email can take up to 10 minutes to
                      arrive.
                    </li>
                    <li>Be sure to check your spam folder.</li>
                    <li>
                      If after 10 minutes, please try entering your email
                      address again
                    </li>
                  </div>
                </v-card-text>
                <v-text-field
                  single-line
                  v-model="code"
                  label="Code"
                  placeholder="Verification Code"
                  class="py-4"
                  hint="You have been sent an email containing the code"
                  id="change-email-code"
                  style="width: 250px"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row class="justify-center mt-9 mb-2"> -->
            <!-- </v-row> -->
            <v-row class="justify-center mt-9 mb-2">
              <v-btn @click="verify()"> Submit </v-btn>
            </v-row>
            <v-row class="justify-center mt-9 mb-2">
              <v-btn
                x-small
                color="transparent"
                class="cancel grey--text"
                elevation="0"
                @click="close()"
              >
                Not right now
              </v-btn>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-card>
  </v-dialog>
  <!-- </v-row> -->
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmailVerify',
  data() {
    return {
      code: '',
      dialog: false,
      storedGroups: [],
    }
  },
  computed: {
    ...mapGetters({
      currentUserProfile: 'getcurrentlySelectedAccountInformationArray',
      groups: 'getUserGroups',
    }),
  },
  watch: {},
  methods: {
    updateEmail() {
      this.$emit('updateUserEmail')
    },
    close() {
      this.$refs.form.reset()
      this.dialog = false
    },
    verify() {
      ;(this.$emit('verifyEmailValidationCode', this.code), this.close())
    },
  },
  mounted: async function () {
    this.storedGroups = JSON.parse(localStorage.getItem('groups'))
  },
}
</script>
